import React from 'react';
import { Button, Switch, Divider } from 'takeat-design-system-ui-kit';
import { IoSparklesSharp } from 'react-icons/io5';
import useWhatsappStore from '~/store/whatsappStore';
import StatusBadge from '~/components/StatusBadge';
import {
  AIAssistantContainer,
  AIStatusBadge,
  AIContentContainer,
  AIIconContainer,
  AIHeaderContainer,
  AITitleText,
  AIDescriptionContainer,
  AIDescriptionText,
  AIStatusRow,
  AIStatusLabel,
} from './styles';

export default function AIAssistant({
  disabled = false,
  onOpenAiTab,
  showConnectionStatus = false,
}) {
  const whatsappStore = useWhatsappStore() || {};
  const {
    isAgentEnabled,
    isAgentLoading = false,
    toggleAgent,
    wppStatus,
  } = whatsappStore;

  const handleToggleAgent = async () => {
    await toggleAgent?.();
  };

  const getSwitchLabel = () => {
    if (isAgentEnabled) return 'Ativo';
    return 'Inativo';
  };

  return (
    <div style={{ marginTop: '16px' }}>
      <AIAssistantContainer>
        <AIStatusBadge>
          <AIContentContainer>
            <AIIconContainer>
              <IoSparklesSharp color="#018CCC" />
            </AIIconContainer>
            <AIHeaderContainer>
              <AITitleText>Inteligência Artificial</AITitleText>
            </AIHeaderContainer>
          </AIContentContainer>
          {disabled ? (
            <span
              style={{
                color: '#545454',
                fontSize: '14px',
                fontFamily: 'Poppins',
                fontWeight: 500,
              }}
            >
              Desativado
            </span>
          ) : (
            <Switch
              label={getSwitchLabel()}
              labelPosition="left"
              checked={isAgentEnabled}
              disabled={isAgentLoading}
              onChange={handleToggleAgent}
            />
          )}
        </AIStatusBadge>
        <AIDescriptionContainer>
          <AIDescriptionText>
            Ative nosso assistente e reduza filas no atendimento.
          </AIDescriptionText>
        </AIDescriptionContainer>
        {showConnectionStatus ? (
          <>
            <div style={{ width: '100%', padding: '5px 0' }}>
              <Divider />
            </div>
            <AIStatusRow>
              <AIStatusLabel>Status</AIStatusLabel>
              <div
                style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}
              >
                <StatusBadge status={wppStatus} />
              </div>
            </AIStatusRow>
          </>
        ) : (
          <Button
            color="red"
            onClick={() => {
              onOpenAiTab();
            }}
            variant="text"
            size="small"
          >
            Saiba mais
          </Button>
        )}
      </AIAssistantContainer>
    </div>
  );
}
